import {forwardRef, useCallback, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {find, sortBy} from 'lodash';
import useActiveModules from '../../../../pages/centralPage/hooks/useActiveModules';
import {agylePref} from '../../../../store/reducers/preferences';
import AgyleDictionaryField from '../../../ui/selector/agyleDictionaryField';
import {MODULE_NAMES} from '../../../../pages/centralPage/constants';

const DEFAULT_STATE = '/central';

const CENTRAL_PAGE_OPTION_OBJ = {
  id: 'centralPage',
  name: MODULE_NAMES.CENTRAL_PAGE,
  description: 'Agyle Home',
  componentPath: '/central',
  devices: ['desktop', 'mobile', 'iPad'],
  enabled: true,
};

// @TODO: Redo redirect on main application view. Currently not working as intended. @Konrad
const DefaultStartingPage = forwardRef((props, ref) => {
  const agylePreference = useSelector(agylePref);

  const [activeModules] = useActiveModules();

  const [defaultStartingPage, setDefaultStartingPage] = useState(agylePreference?.defaultStartingPage ? agylePreference?.defaultStartingPage : DEFAULT_STATE);
  const selectableModules = sortBy([...activeModules, CENTRAL_PAGE_OPTION_OBJ], 'description');

  // Return default state of a component
  useImperativeHandle(ref, () => ({
    defaultState: () => {
      setDefaultStartingPage(DEFAULT_STATE);
      return DEFAULT_STATE;
    },
  }));

  const handleChange = (_ev, val) => {
    let clone = defaultStartingPage;
    clone = val.componentPath;
    setDefaultStartingPage(clone);
    props.onChange('defaultStartingPage', clone);
  };

  const findCurrentValue = useCallback(() => find(selectableModules, {componentPath: defaultStartingPage})
    , [selectableModules, activeModules, defaultStartingPage]);

  return (
      <AgyleDictionaryField
        paperBackground
        withBackground={false}
        onChange={handleChange}
        value={findCurrentValue()}
        options={selectableModules}
        getOptionLabel={option => option.description}
        isOptionEqualToValue={(option, value) => option.componentPath === value}
      />
  );
})

export default DefaultStartingPage;